import { Hidden } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { BorderRight } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    boxShadow: '0px 1px 0px #E2EBF6',
    padding: '0 25px',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      padding: '0 15px',
    },
  },
  backAction: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 25px 8px 0',
    boxShadow: '1px 0px 0px #E2EBF6',
    [theme.breakpoints.down('sm')]: {
      padding: '8px 15px 8px 0',
      boxShadow: 'none',
      borderBottom: '1px solid #E2EBF6',
      justifyContent: 'center'
    },
  },
  backButtonTitle: {
    color: '#59758B',
  },
  backIcon: {
    fontSize: '18px',
    color: '#59758B',
  },
  headerTitle: {
    borderLeft: '1px solid #E2EBF6',
    borderRadius: 0,
    color: '#071B27',
    marginLeft: '5px',
    paddingLeft: '15px',
    fontWeight: 'bold',
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
      width: '100%',
      justifyContent: 'center',
      display: 'flex',
      borderLeft: 'hidden',
      paddingRight: '30px'
      
    },
  },
  rangeWrapper: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '30px',
    [theme.breakpoints.down('sm')]: {
      // paddingLeft: '15px',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  button: {
    border: '1px solid #0E8BB4',
    borderRadius: '3px',
    padding: '5px 29px',
    [theme.breakpoints.down('sm')]: {
      padding: '5px 20px',
      marginTop: '10px',
      marginBottom: '10px'
    },
  },
  todayTitle: {
    color: '#0E8BB4',
    fontWeight: 'bold',
  },
  range: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '30px',
    [theme.breakpoints.down('sm')]: {
      marginLeft: '15px',
    },
  },
  rangeIcon: {
    fontSize: '15px',
    border: '1px solid #000',
    borderRadius: '100%',
    padding: '1px',
    cursor: 'pointer',
  },
  rangeDates: {
    margin: '0 15px',
  },
  disabledRangeIcon: {
    cursor: 'not-allowed',
  },
  datePickerButton: {
    marginBottom: '0',
    marginLeft: '20px',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      marginLeft: '10px',
      
    },
    '& .inputSinglePicker': {
      position: 'absolute',
      top: '-5px',
    },
    '& .DateInput_input': {
      cursor: 'default',
    },
  },

  datePickerWrapper: {
    position: 'relative',
    '& .SingleDatePicker_picker': {
      [theme.breakpoints.down('sm')]: {
        left: 'auto !important', // Override left positioning
        right: 0, // Position to the right
      },
    },
  }
}));

export default useStyles;
